import { render, staticRenderFns } from "./ProcurationStep4.vue?vue&type=template&id=816d4b68&scoped=true&"
import script from "./ProcurationStep4.vue?vue&type=script&lang=js&"
export * from "./ProcurationStep4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816d4b68",
  null
  
)

export default component.exports